import { render, staticRenderFns } from "./BeneficiarioFamiliaListado.vue?vue&type=template&id=5761a786"
import script from "./BeneficiarioFamiliaListado.vue?vue&type=script&lang=js"
export * from "./BeneficiarioFamiliaListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports